var _circle, _path, _path2, _rect, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHow1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 392,
    viewBox: "0 0 301 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150.373,
    cy: 240.636,
    r: 124.645,
    transform: "rotate(13.5458 150.373 240.636)",
    fill: "#BCC015"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.346 301.007L99.6625 303.943C88.0549 304.259 78.3905 295.122 78.0755 283.536L71.1637 27.2847C70.8523 15.699 80.0109 6.05455 91.6185 5.73863L200.302 2.80288C211.909 2.4906 221.574 11.6277 221.889 23.2096L228.8 279.461C229.112 291.051 219.957 300.695 208.346 301.007Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.862 275.392L97.6206 278.418C91.1821 278.592 85.8246 273.502 85.6501 267.05L79.1096 24.9353C78.9351 18.4828 84.0113 13.1093 90.4497 12.9355L202.691 9.90878C209.13 9.73502 214.487 14.825 214.662 21.2774L221.202 263.392C221.377 269.844 216.297 275.218 209.862 275.392Z",
    fill: "#F8F8F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 107.211,
    width: 67,
    height: 67,
    rx: 16.4754,
    transform: "rotate(-1.03511 116 107.211)",
    fill: "#162F26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.345 129.811L155.345 129.81L165.655 139.754L145.767 160.373L135.458 150.43L145.401 140.12L135.09 130.176L145.034 119.866L155.345 129.811Z",
    fill: "#BCC015"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.436 32.3526L177.638 33.2611C175.192 33.3507 173.114 31.3124 173.019 28.7325L172.802 22.8009C172.707 20.2209 174.631 18.0361 177.077 17.9465L201.875 17.038C204.321 16.9484 206.399 18.9867 206.494 21.5666L206.711 27.4944C206.806 30.0782 204.882 32.263 202.436 32.3526Z",
    fill: "#CBD212"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.344 30.084L180.11 30.0926C178.481 30.1522 177.118 28.9382 177.061 27.3858L176.93 23.8264C176.873 22.2705 178.148 20.9633 179.773 20.9038L180.007 20.8952C181.636 20.8356 182.999 22.0495 183.056 23.602L183.186 27.1614C183.247 28.7137 181.972 30.0243 180.344 30.084Z",
    fill: "#353535"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHow1);
export default __webpack_public_path__ + "static/media/how1.40c82ec1efe8424c90e6591eb420e77d.svg";
export { ForwardRef as ReactComponent };